<template>
    <button class="btn btn-delete m-1" @click.prevent="eventHandle(page)">
        <font-awesome-icon icon="fa-trash-alt" size="lg" class="link-icon" />
    </button>
</template>

<script setup>
import { defineEmits } from 'vue';

const emits = defineEmits(['delete']);
const eventHandle = () => {
    emits('delete');
};
</script>